var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://baserow.io","target":"_blank","title":"Baserow - open source no-code database tool and Airtable alternative"}},[_c('Logo',{attrs:{"height":"14","alt":"Baserow - open source no-code database tool and Airtable alternative"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }